module.exports = __webpack_public_path__ + "img/default_img.ac0b247d.png";